import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { MessageService } from "primeng/api";
import { providePrimeNG } from "primeng/config";
import Aura from "@primeng/themes/aura";
import { definePreset } from "@primeuix/themes";
import { routes } from "./app.routes";
import { authInterceptor } from "./core/interceptors/auth.interceptor";

// Preset Aura personnalisé : couleur primaire or ambré du back-office Menuvia
const MenuviaPreset = definePreset(Aura, {
  primitive: {
    menuvia: {
      50:  "#FEF9EC",
      100: "#FEF3C7",
      200: "#F5E08A",
      300: "#DEB84F",
      400: "#C49030",
      500: "#8B6914",
      600: "#6B5010",
      700: "#55400C",
      800: "#3E2F08",
      900: "#291F05",
      950: "#1A1303",
    },
  },
  semantic: {
    primary: {
      50:  "{menuvia.50}",
      100: "{menuvia.100}",
      200: "{menuvia.200}",
      300: "{menuvia.300}",
      400: "{menuvia.400}",
      500: "{menuvia.500}",
      600: "{menuvia.600}",
      700: "{menuvia.700}",
      800: "{menuvia.800}",
      900: "{menuvia.900}",
      950: "{menuvia.950}",
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({ theme: { preset: MenuviaPreset, options: { darkModeSelector: ".dark" } } }),
    MessageService,
  ],
};
